import { 
   
    Code, 
    Palette, 
    Package, 
    Zap,
    Layout,
    Shield,
    Laptop,
    Database
  } from 'lucide-react';



  
  interface NavItem {
    title: string;
    id: string;
    icon: React.ElementType;
    subItems?: { title: string; id: string }[];
  }
  


export const navItems: NavItem[] = [
    {
      title: 'Getting Started',
      id: 'getting-started',
      icon: Zap,
      subItems: [
        { title: 'Installation', id: 'installation' },
        { title: 'Quick Start', id: 'quick-start' },
        { title: 'Prerequisites', id: 'prerequisites' },
      ],
    },
    {
      title: 'Templates',
      id: 'templates',
      icon: Package,
      subItems: [
        { title: 'Landing Page', id: 'landing-page' },
        { title: 'Dashboard', id: 'dashboard' },
        { title: 'E-commerce', id: 'ecommerce' },
      ],
    },
    {
      title: 'Customization',
      id: 'customization',
      icon: Palette,
      subItems: [
        { title: 'Theming', id: 'theming' },
        { title: 'Components', id: 'components' },
        { title: 'Layout', id: 'layout' },
      ],
    },
    {
      title: 'Development',
      id: 'development',
      icon: Code,
      subItems: [
        { title: 'Configuration', id: 'configuration' },
        { title: 'Build Process', id: 'build-process' },
        { title: 'Deployment', id: 'deployment' },
      ],
    },
    {
      title: 'Architecture',
      id: 'architecture',
      icon: Layout,
      subItems: [
        { title: 'Project Structure', id: 'project-structure' },
        { title: 'Design Patterns', id: 'design-patterns' },
        { title: 'Best Practices', id: 'best-practices' },
      ],
    },
    {
      title: 'Performance',
      id: 'performance',
      icon: Laptop,
      subItems: [
        { title: 'Optimization', id: 'optimization' },
        { title: 'Caching', id: 'caching' },
        { title: 'Lazy Loading', id: 'lazy-loading' },
      ],
    },
    {
      title: 'Security',
      id: 'security',
      icon: Shield,
      subItems: [
        { title: 'Authentication', id: 'authentication' },
        { title: 'Authorization', id: 'authorization' },
        { title: 'Data Protection', id: 'data-protection' },
      ],
    },
    {
      title: 'Database',
      id: 'database',
      icon: Database,
      subItems: [
        { title: 'Setup', id: 'db-setup' },
        { title: 'Migrations', id: 'migrations' },
        { title: 'Queries', id: 'queries' },
      ],
    },
  ];